require('./RAGoalBar.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');

class RAGoalBar extends React.Component {
    render() {
        const { height, amount, text, date, extraClass, top } = this.props;
        const className = classnames('ra-goal-bar', extraClass);

        return (
            <div className={className} style={{ top }}>
                <div className="ra-goal-bar__text-container">
                    <span className="ra-goal-bar__amount">{amount}</span>
                    <span className="ra-goal-bar__text hidden-xs">{text}</span>
                    <span className="ra-goal-bar__text hidden-xs">{date}</span>
                </div>
                <div className="ra-goal-bar__head" />
                <div className="ra-goal-bar__body" style={{ height }} />
            </div>
        );
    }
}

RAGoalBar.propTypes = {
    amount: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    height: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired,
    extraClass: PropTypes.string,
};

module.exports = RAGoalBar;
